module.exports = __webpack_public_path__ + "static/media/NewMetaNotebook.f38e9bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/AppDevelopment/NewMetaNotebook.png
// module id = 461
// module chunks = 0